<template>
  <div>
    <q-card class="shadow-10-disabled flat bordered card-login">
      <q-card-section class="text-center">
        <a href="https://www.suez.es/es-es">
          <q-img
            style="height: 97px; max-width: 306px"
            :src="require('@/assets/img/logo-dinapsis.svg')"
          />
        </a>
      </q-card-section>
      <div class="txtInfo txtPadding">
        Hemos enviado un email para resetear su contraseña, a la siguiente
        cuenta.
      </div>
      <div class="txtEmail txtPadding">
        {{ datos }}
      </div>
      <div class="txtInfo">
        Revise su bandeja de entrada y siga las instrucciones.
      </div>
      <div class="txtInfo">
        Si no le ha llegado ningún correo, es posible que no esté dado de alta
        en la plataforma.
      </div>
      <div class="txtPadding" />
    </q-card>
  </div>
</template>
<script>
import { QImg } from 'quasar';
export default {
  name: 'suez-login',
  components: {
    QImg
  },
  props: {
    datos: String
  }
};
</script>
<style lang="scss" scoped>
$verde: #9fce4d;
$azuloscuro: hsl(222, 58%, 13%);
$azuloclaro: #878b97;
$seafoam-blue: #72c7d7;
$seafoam-blue-hover: #5795a1;
$verde-suez: #8dbe2d;

.card-login {
  padding: 16px 70px 47px 70px;
}

.buttonoscuro {
  width: 100%;
  background-color: $seafoam-blue !important;
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  text-align: center;
  &:hover {
    background-color: $seafoam-blue-hover !important;
    color: #fff;
    font-weight: 500;
  }
}

.buttonclaro {
  width: 100%;
  background-color: $azuloclaro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $verde !important;
    color: $azuloclaro;
    font-weight: 600;
  }
}

a {
  width: 100%;
  border: none;
  color: $verde-suez;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.23px;
  text-align: center;
  &:hover {
    /* color: rgb(71, 70, 70); */
    /* font-weight: 300; */
  }
  &:link {
    text-decoration: none;
  }
}
.txtInfo {
  width: 100%;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: #1c2d72;
}
.txtEmail {
  width: 100%;
  height: 21px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.23px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}
.txtPadding {
  padding-top: 20px;
  padding-bottom: 40px;
}
</style>
